import { busbar_registry } from "./busbar_registry";
import { formatDateTime, random, round2 } from "../helpers/helpers";

export const generate_busbar_latest_dashboard_demo = () => {
    let active = 0;
    let inactive = 0;

    const sensors = [];

    busbar_registry.forEach(location => {
        location.sensors.forEach((sensor, index) => {

            active++;


            sensors.push({
                meter_id: sensor.meter_id,
                sensor_name: sensor.sensor_name,

                location: location.location,
                location_id: location.location_id,

                status:  "Online",
                last_seen: formatDateTime(Date.now()),

                temperature_r: round2(random(24, 32)),
                temperature_y: round2(random(24, 32)),
                temperature_b: round2(random(24, 32)),
            });
        });
    });

    return {
        active,
        inactive,
        total: sensors.length,
        sensors,
    };
};